<template>
  <section class="subscribeBottomWrap">
    <img
      src="https://image.insideburgundy.cn/insideburgundy/20190522/fb8165ef7cb041bcb5dfc99d09e19a3a.png"
      alt
      class="cover-image"
    >

    <div class="container">
      <div class="subscribeBottom">
        <div class="subscribeBottomContent animate fadeInUp triggeredCSS3">
          <div>
            <h4>现在就注册Inside Burgundy，享受探索勃艮第葡萄酒带来的⽆限乐趣</h4>
            <ul>
              <li>掌握勃艮第葡萄酒和产区的最新动态</li>
              <li>获得最新主题品鉴和大师班活动通知</li>
              <li>学习勃艮第葡萄酒小知识</li>
              <li>和其它勃艮第爱好者进行线上互动</li>
              <li>注册完全免费，仅订阅内容收费</li>
            </ul>
          </div>
        </div>
        <div class="subscribeBottomForm animate fadeInUp triggeredCSS3">
          <form
            @submit="submit"
            id="wppb-register-user-guest-registration"
            class="wppb-user-forms wppb-register-user wppb-user-logged-out"
          >
            <ul>
              <li class="wppb-form-field wppb-default-name-heading" id="wppb-form-element-1">
                <h4>基本资料</h4>
                <span class="wppb-description-delimiter"></span>
              </li>
              <li class="wppb-form-field wppb-default-first-name" id="wppb-form-element-3">
                <label for="nickName">用户名
                  <span class="wppb-required" title="This field is required">*</span></label>
                <input
                  class="text-input default_field_firstname"
                  name="nickName"
                  maxlength="70"
                  type="text"
                  v-model="submitData.nickName"
                  id="nickName"
                >
              </li>
              <li class="wppb-form-field wppb-default-last-name" id="wppb-form-element-4">
                <label for="mobile">电话
                  <span class="wppb-required" title="This field is required">*</span>
                </label>
                <input
                  class="text-input default_field_lastname"
                  name="mobile"
                  maxlength="70"
                  v-model.number="submitData.mobile"
                  type="text"
                  id="mobile"
                >
              </li>
              <li class="wppb-form-field wppb-default-e-mail" id="wppb-form-element-8">
                <label for="email">
                  邮箱
                  <span class="wppb-required" title="This field is required">*</span>
                </label>
                <input
                  class="text-input default_field_email"
                  name="email"
                  maxlength="70"
                  type="email"
                  v-model="submitData.email"
                  id="email"
                  required
                >
              </li>
              <li class="wppb-form-field wppb-default-username" id="wppb-form-element-2">
                <label for="vcode">
                  验证码
                  <span class="wppb-required" title="This field is required">*</span>
                </label>
                <input
                  class="text-input default_field_username"
                  name="vcode"
                  maxlength="70"
                  type="text"
                  id="vcode"
                  v-model="submitData.vcode"
                  required
                >
                <div
                  style="    text-align: center;
    width: 480px;
    height: 56px;
    margin-left: 126px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-top: 22px;"
                >
                  <button
                    @click="getcode"
                    type="button"
                    style="border: 1px;
    margin-top: -5px;
    width: 100px;
    margin: 0 auto;
    text-align: center;
    height: 42px;
    background: #970635;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;"
                  >发送验证码</button>
                  <span
                    style="color:#999999;width: 200px;
    /* height: 16px; */
    font-size: 13px;
    display: inline-block;
    margin-right: 163px;"
                  >我们将向您填写的手机号码发送验证短信，请注意查收</span>
                </div>
              </li>
              <li class="wppb-form-field wppb-default-password" id="wppb-form-element-12">
                <label for="passw1">
                  密码
                  <span class="wppb-required" title="This field is required">*</span>
                </label>
                <input
                  class="text-input"
                  name="passw1"
                  maxlength="70"
                  type="password"
                  id="passw1"
                  v-model="submitData.password"
                  autocomplete="off"
                  required
                >
              </li>
              <li class="wppb-form-field wppb-default-repeat-password" id="wppb-form-element-13">
                <label for="passw2">
                  确认密码
                  <span class="wppb-required" title="This field is required">*</span>
                </label>
                <input
                  class="text-input"
                  name="passw2"
                  maxlength="70"
                  type="password"
                  id="passw2"
                  v-model="submitData.password1"
                  autocomplete="off"
                  required
                >
              </li>
              <li class="wppb-form-field wppb-recaptcha" id="wppb-form-element-16">
                <div id="wppb-recaptcha-element-pb_register1" class="wppb-recaptcha-element"></div>
              </li>
              <li class="wppb-form-field wppb-mailchimp-subscribe" id="wppb-form-element-17">
                <label for="custom_field_mailchimp_subscribe_17">
                  <input
                    name="custom_field_mailchimp_subscribe_17"
                    id="custom_field_mailchimp_subscribe_17"
                    class="extra_field_mailchimp"
                    type="checkbox"
                    v-model="submitData.check"
                  >我已阅读并同意《Inside Burgundy注册条款》
                </label>
              </li>
            </ul>
            <ul></ul>
            <p class="form-submit">
              <input name="register" type="submit" id="register" class="submit button" value="注册">
              <input name="action" type="hidden" id="action" value="注册">
              <input name="form_name" type="hidden" id="form_name" value="guest-registration">
              <input type="hidden" name="wppb_referer_url" value>
            </p>
            <!-- .form-submit -->
            <input
              type="hidden"
              id="register_guest-registration_nonce_field"
              name="register_guest-registration_nonce_field"
              value="5951aa51cb"
            >
            <input type="hidden" name="_wp_http_referer" value="/">
          </form>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ajax from "../ajax";
export default {
  data() {
    return {
      submitData: {
        email: "",
        encryption: "",
        mobile: "",
        nickName: "",
        password: "",
        password1: "",
        check: false,
        vcode: ""
      }
    };
  },
  methods: {
    submit(e) {
      e.preventDefault();
      if (!this.submitData.check) return alert("请阅读并同意条款！");
      if (this.submitData.password !== this.submitData.password1)
        return alert("两次输入的密码不一致！");
      let query = JSON.parse(JSON.stringify(this.submitData));
      delete query.password1;
      delete query.check;
      ajax.postRegister(this.submitData).then(res => {
        if (res.success) {
          this.$store.commit("setuserdata", res.data);
          this.$store.commit("setUsername", res.data.nickname);
          this.$store.commit("setLogin");
          alert("恭喜注册成功！");
          this.$router.push("/home");
        } else {
          alert("注册失败：" + res.message);
        }
      });
    },
    getcode() {
      let mobile = this.submitData.mobile;
      if (mobile) {
        ajax
          .postSendCode({ mobile, usage: "register" })
          .then(res => {
            if (res.success) {
              this.submitData.encryption = res.data;
              alert("验证码发送成功，请注意查收！");
            } else {
              alert(res.message);
            }
          });
      } else {
        alert("请正确填写手机号码！");
        $("#mobile").focus();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/template/register.vue